<template>
    <div v-if="isTrial">
        <!-- Barra sutil persistente mientras dure la prueba -->
        <div class="trial-bar" :class="{ 'trial-bar--urgent': urgent }">
            <span class="trial-bar__text">
                <i class="pi pi-gift"></i>
                <span class="trial-bar__full">{{ fullText }}</span>
                <span class="trial-bar__compact">{{ compactText }}</span>
            </span>
            <Button
                label="Activar mi plan"
                icon="pi pi-check"
                class="p-button-sm p-button-rounded trial-bar__cta"
                @click="goActivate"
            />
        </div>

        <!-- Modal de bienvenida (solo la 1ª vez tras crear la cuenta) -->
        <Dialog
            v-model:visible="welcomeVisible"
            :modal="true"
            :draggable="false"
            class="trial-welcome"
            :style="{ width: '32rem' }"
            :breakpoints="{ '575px': '92vw' }"
        >
            <template #header>
                <div class="trial-welcome__header"><i class="pi pi-gift"></i> ¡Bienvenido a Contablus!</div>
            </template>
            <p class="trial-welcome__lead">
                Estás en tu <strong>prueba gratis de 14 días</strong><span v-if="planName"> del plan {{ planName }}</span>.
                Factura de verdad desde hoy; cuando quieras, activa tu plan para continuar sin interrupciones.
            </p>
            <p v-if="remainingDays > 0" class="trial-welcome__days">
                Te quedan <strong>{{ remainingDays }}</strong> {{ daysLabel }}.
            </p>
            <template #footer>
                <Button label="Entendido" class="p-button-text" @click="closeWelcome" />
                <Button label="Activar mi plan" icon="pi pi-check" class="p-button-rounded" @click="activateFromWelcome" />
            </template>
        </Dialog>
    </div>
</template>

<script>
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import { trialWelcomeKey } from './trialWelcome';

export default {
    name: 'TrialBar',
    components: { Button, Dialog },
    data() {
        return { welcomeVisible: false };
    },
    computed: {
        subscription() { return this.$store.getters.subscription; },
        isTrial() { return !!(this.subscription && this.subscription.isTrial); },
        remainingDays() { return (this.subscription && this.subscription.remainingDays) || 0; },
        planName() { return (this.subscription && this.subscription.planName) || ''; },
        urgent() { return this.isTrial && this.remainingDays <= 3; },
        daysLabel() { return this.remainingDays === 1 ? 'día' : 'días'; },
        fullText() {
            return this.remainingDays > 0
                ? `Prueba gratis · te quedan ${this.remainingDays} ${this.daysLabel}`
                : 'Tu prueba gratis ha finalizado — activa tu plan para seguir facturando';
        },
        compactText() {
            return this.remainingDays > 0 ? `Prueba · ${this.remainingDays} ${this.daysLabel}` : 'Prueba finalizada';
        },
        welcomeKey() { return trialWelcomeKey(this.$store.getters.business); },
    },
    watch: {
        isTrial: {
            immediate: true,
            handler(val) { if (val) this.$nextTick(() => this.maybeShowWelcome()); },
        },
    },
    methods: {
        maybeShowWelcome() {
            try { if (localStorage.getItem(this.welcomeKey)) return; } catch (e) { /* noop */ }
            this.welcomeVisible = true;
        },
        markWelcomeSeen() {
            try { localStorage.setItem(this.welcomeKey, '1'); } catch (e) { /* noop */ }
        },
        closeWelcome() { this.markWelcomeSeen(); this.welcomeVisible = false; },
        goActivate() {
            if (this.$route.name !== 'suscripcion') this.$router.push({ name: 'suscripcion' });
        },
        activateFromWelcome() { this.closeWelcome(); this.goActivate(); },
    },
};
</script>

<style scoped lang="scss">
.trial-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.5rem 1rem;
    margin-bottom: 1rem;
    border-radius: 10px;
    background: #eaf0fb;            /* azul muy claro (marca) */
    border: 1px solid #c7d6f0;
    color: #18407F;
    font-size: 0.9rem;
}
.trial-bar--urgent {
    background: #fdf0e1;            /* naranja muy claro */
    border-color: #f6c893;
    color: #a85f09;
}
.trial-bar__text { display: inline-flex; align-items: center; gap: 0.5rem; min-width: 0; }
.trial-bar__text .pi { font-size: 1rem; }
.trial-bar__full { font-weight: 600; }
.trial-bar__compact { display: none; font-weight: 600; }
.trial-bar__cta { flex-shrink: 0; background: #18407F; border-color: #18407F; }
.trial-bar--urgent .trial-bar__cta { background: #f18700; border-color: #f18700; }

.trial-welcome__header { display: inline-flex; align-items: center; gap: 0.5rem; font-weight: 700; color: #18407F; }
.trial-welcome__header .pi { color: #f18700; }
.trial-welcome__lead { margin: 0 0 0.5rem; line-height: 1.5; }
.trial-welcome__days { margin: 0; color: #18407F; }

@media (max-width: 575px) {
    .trial-bar { padding: 0.45rem 0.6rem; font-size: 0.82rem; gap: 0.5rem; }
    .trial-bar__full { display: none; }
    .trial-bar__compact { display: inline; }
}
</style>
